export default __webpack_public_path__ + "static/dropdownMenu_cloud_left-0d70344eb00406df46c4712a4f4ba51a.webp";